import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  searchFilterWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 24px',
    margin: '16px 0px 24px',
    height: '100%',
  },
  searchWrap: {
    width: '100%',
  },
  clickableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme?.palette?.grey[700],
    },
  },
}));

export default useStyles;
